import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SavedContentBlock = lazy(() =>
  import("@scenes/MessageComposition/ContentBlocks/SavedContentBlock").then((module) => ({
    default: module.SavedContentBlock,
  }))
);

export const savedContentBlockNRO: NavigationRoutingObject = {
  componentFeatureFlippers: [],
  Component: SavedContentBlock,
  noKnockoutFallback: true,
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) => t("saved-content-block-nro-heading", "Saved Content Block"),
  pageNameForTracking: () => "Saved Content Block",
  icon: "nav-system-content-blocks",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/templates_and_media/content_blocks/:appGroupId",
};
